/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1MinusIcon16Light = forwardRef('People1MinusIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.498 4.502a3.502 3.502 0 1 1 7.004 0 3.502 3.502 0 0 1-7.004 0ZM8 2a2.502 2.502 0 1 0 0 5.003A2.502 2.502 0 0 0 8 2Z" }),
        React.createElement("path", { d: "M3.518 11.575c-.31.457-.518 1.075-.518 1.93a.5.5 0 0 1-1 0c0-1.025.252-1.846.69-2.491.436-.643 1.032-1.078 1.669-1.372 1.254-.58 2.726-.637 3.641-.637a.5.5 0 0 1 0 1c-.903 0-2.181.064-3.222.544-.511.237-.949.567-1.26 1.026Z" }),
        React.createElement("path", { d: "M10.5 11a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z" })));
});
